<template>
  <v-card outlined rounded id="drivers-license-card">
    <v-card-title>
      <v-icon class="mr-2" color="primary">mdi-card-account-details</v-icon>
      <span data-testid="license-card-name" class="subtitle-1">{{ fullName }}</span>
      <v-spacer/>
      <Icon
        v-if="showCrud"
        dataTestId="license-edit-button"
        icon="mdi-pencil"
        iconColor="success"
        :tooltipText="$t('edit')"
        tabindex="0"
        @icon-clicked="$emit('click:edit', license)"
        elementId="edit-license"/>
      <Icon
        v-if="showCrud"
        dataTestId="license-delete-button"
        icon="mdi-delete-forever"
        iconColor="error"
        :tooltipText="$t('delete')"
        tabindex="0"
        @icon-clicked="openDeleteDialog"
        elementId="delete-license"/>
    </v-card-title>
    <v-card-text class="mt-n2">
      <v-container fluid grid-list-sm>
        <v-row no-gutters class="ml-n2">
          <v-col cols="12">
            <span class="font-weight-medium">{{ $t('licenseNumber') }}:</span> {{ license.licenseNumber }}
          </v-col>
          <v-col cols="12">
            <span class="font-weight-medium">{{ $t('state') }}:</span> {{ license.state }}
          </v-col>
          <v-col cols="12" v-if="license.expirationDate">
            <span class="font-weight-medium">{{ $t('expirationDate') }}: </span>
            <span :class="isExpired ? 'error--text' : ''">{{ formattedExpirationDate }}</span>
            <v-icon v-if="isExpired" small color="error" class="ml-1">mdi-alert</v-icon>
          </v-col>
          <v-col cols="12">
            <span class="font-weight-medium">{{ $t('licenseType') }}:</span> {{ licenseTypeName }}
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-dialog width="400px" v-model="openDialog">
      <ConfirmDialog
        v-if="openDialog"
        :title="$t('deleteDriversLicense')"
        :body="$t('deleteDriversLicenseBody')"
        @confirm="deleteLicense"
        @cancel="openDialog = ''"/>
    </v-dialog>
  </v-card>
</template>

<script>
import { LicenseType } from '@/utils/Enumerations'
import moment from 'moment'

export default {
  name: 'DriversLicenseCard',

  components: {
    ConfirmDialog: () => import('@/components/helper/ConfirmDialog.vue'),
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    license: {
      type: Object,
      required: true
    },
    showCrud: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    openDialog: ''
  }),

  computed: {
    fullName () {
      const parts = [this.license.firstName, this.license.middleName, this.license.lastName].filter(Boolean)
      return parts.join(' ')
    },

    formattedExpirationDate () {
      return this.license.expirationDate ? moment(this.license.expirationDate).format('MM/DD/YYYY') : ''
    },

    isExpired () {
      if (!this.license.expirationDate) return false
      return moment(this.license.expirationDate).isBefore(moment())
    },

    licenseTypeName () {
      return LicenseType.fromInt(this.license.type)
    }
  },

  methods: {
    openDeleteDialog () {
      this.openDialog = 'delete'
    },

    deleteLicense () {
      this.$emit('click:delete', this.license)
      this.openDialog = ''
    }
  }
}
</script>
